import React from 'react';
import { useSelector } from "react-redux";
import { selectActiveView, WhereaboutsView } from "@shared/store/dashboard.duck";
import TeamMovementsList from "./TeamMovementsList";
import { selectCurrentUser } from "@shared/store/auth.duck";
import { AddTeamMember } from "./AddTeamMember";
import { MonthlyWhereaboutsView } from "@features/wall-planner/pages/MonthlyWhereaboutsView";
import { useWhereaboutsScope } from '@features/whereabouts/pages/whereabouts-v2/WhereaboutsScopeContext';

export function WhereaboutsViews(props: Props) {
  const activeView = useSelector(selectActiveView);
  const current = useSelector(selectCurrentUser);
  const { isScoped } = useWhereaboutsScope();

  return (
    <>
      {activeView === WhereaboutsView.Week && <>
        <TeamMovementsList hideDateFlicker={props.hideDateFlicker} hideDayHeaders={props.hideDayHeaders} />
        {!isScoped && current?.teamEntity && <AddTeamMember className="teamMovements__add--mobile"/>}
      </>}
      {activeView === WhereaboutsView.Month && <>
        <MonthlyWhereaboutsView />
      </>}
    </>
  )
}

interface Props {
  hideDateFlicker?: boolean;
  hideDayHeaders?: boolean;
}
